import React from 'react';
import classes from './styles.module.scss';

export default function Button({
	children,
	size = 'md',
	onClick,
	type = 'button',
	disabled = false,
	variant = 'primery',
	endIcon,
	style,
	block = false,
	propsClasses = '',
}: {
	children?: React.ReactNode;
	size?: 'sm' | 'md' | 'lg';
	onClick?: (...event: any[]) => void | Promise<void>;
	type?: 'button' | 'reset' | 'submit';
	disabled?: boolean;
	variant?: 'primery' | 'secondary' | 'violet' | 'green' | 'orange' | null;
	endIcon?: JSX.Element;
	style?: object;
	block?: boolean;
	propsClasses?: string | string[];
}) {
	return (
		<button
			style={style}
			onClick={onClick}
			className={[
				classes.btn,
				classes[`btn--${size}`],
				variant && classes[`btn-${variant}`],
				block && classes['btn--block'],
				Array.isArray(propsClasses) ? propsClasses.join(' ') : propsClasses
			].filter(Boolean).join(' ')}
			type={type}
			disabled={disabled}
		>
			{children && <span>{children}</span>}
			{endIcon}
		</button>
	);
}

